var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableHeaderStockManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 51,
    viewBox: "0 0 59 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1517 47.6601C16.1667 47.8528 17.0719 47.9666 17.1167 47.8181C17.0015 47.6601 16.557 47.5843 15.1528 47.3821C14.3436 47.2683 13.0322 46.9334 12.8691 46.7849C12.6388 46.469 13.3872 46.5353 13.7902 46.6269C13.8318 46.6364 17.9739 47.4958 18.2905 46.9239C18.6136 46.3426 17.4269 46.1435 16.7169 46.033C15.994 45.9192 15.623 45.3126 15.8949 45.2084C16.2307 45.082 16.9568 45.7928 18.1338 45.9097C19.1637 46.0109 20.6479 46.232 21.294 46.371L21.9145 46.7754L23.8144 46.6427L23.7184 48.4879L22.2631 48.8512C21.0253 49.2872 19.1861 49.8591 17.9611 50.0613C16.6721 50.2761 15.5782 50.2319 15.0249 50.1308C14.8905 50.1055 14.8809 49.938 15.0121 49.9191C15.3511 49.8717 15.8501 49.8496 16.1987 49.8306C17.347 49.7738 17.7372 49.5526 17.8012 49.3251C17.638 49.1608 17.1871 49.1671 15.6038 49.2651C14.8713 49.3093 13.8702 49.3725 13.7103 49.3062C13.0674 48.8765 14.705 48.8133 15.4439 48.8164C16.2051 48.8196 17.0175 48.8923 17.1135 48.5637C17.1455 48.4563 16.1539 48.3015 14.9161 48.2572C10.419 48.1087 11.9415 47.4484 14.1517 47.6601Z",
    fill: "#FC7575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5618 27.0469C43.5618 27.0469 41.0126 38.4809 33.9055 43.2548C26.7984 48.0287 22.2021 45.9593 22.2021 45.9593V49.5769C22.2021 49.5769 36.3076 55.1817 41.9082 46.0762C47.5088 36.9707 43.5618 27.0469 43.5618 27.0469Z",
    fill: "#6C6B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7769 22.3174C46.7769 22.3174 42.0847 27.6316 40.5686 34.8731C39.8841 38.1368 41.1699 46.285 40.7445 54.2689C40.2264 63.9968 38.0674 68.0251 38.0674 68.0251L63.1501 65.7187C63.2749 60.9195 62.5744 24.9113 52.8829 22.6871C48.5969 21.6982 46.7769 22.3174 46.7769 22.3174Z",
    fill: "#D4D1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5983 25.1301C51.7281 25.6293 46.5849 32.5485 45.6925 38.8895C44.8001 45.2305 45.0272 48.074 42.7787 50.9649C40.6069 53.7579 28.9259 62.1525 28.2158 62.6643L31.4495 65.1161C33.1223 64.7527 46.2746 57.9252 50.6886 55.088C55.1537 52.2129 60.991 24.4319 55.5983 25.1301Z",
    fill: "#5F5D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5983 25.1299C52.2047 25.4521 48.7023 30.0649 47.0231 33.5214C45.088 37.4012 45.2383 40.4216 44.4611 45.4925C43.6582 51.2459 41.8991 51.8082 28.2158 62.6641C31.6382 60.3893 34.9839 58.0008 38.2336 55.4795C42.833 51.9473 44.4899 50.4055 45.2479 45.6063C45.7981 41.8907 45.6893 32.166 52.8828 26.4821C53.6792 25.866 54.5748 25.3131 55.5983 25.1299Z",
    fill: "#4F4D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7894 13.1836C52.7894 13.1836 53.2691 19.0254 52.7158 22.8389C52.5783 23.7898 52.0025 24.6208 51.1581 25.0947C49.4597 26.0457 46.5075 27.4327 45.4424 26.3016L47.0768 17.2214L52.7894 13.1836Z",
    fill: "#F09959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7903 13.1836L47.0745 17.2214L46.2461 21.8278C51.0567 21.6541 52.576 14.2578 52.8286 13.7175C52.8062 13.3763 52.7903 13.1836 52.7903 13.1836Z",
    fill: "#E38540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5995 4.69478C45.5132 4.75481 45.4108 4.87487 45.2989 5.04548C44.7871 5.82271 44.1154 7.67414 44.2114 9.97737C44.3297 12.7798 44.3393 18.65 46.4056 19.0639C48.4718 19.4778 51.8079 17.2473 52.7162 13.9709C53.6246 10.6946 55.3902 9.32021 54.6897 6.5241C53.986 3.72799 45.5995 4.69478 45.5995 4.69478Z",
    fill: "#F09959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5998 4.69399C45.5998 4.69399 53.9895 3.72404 54.69 6.52015C55.3904 9.31626 53.6249 10.6906 52.7165 13.967C52.1439 13.373 51.5746 12.8643 51.6865 9.80597C51.1076 7.65439 49.7227 7.67966 49.5307 6.73499C47.5797 7.10148 47.327 8.09987 47.1958 8.20729C46.2811 9.60692 45.3343 10.7412 44.2596 11.2372C44.2436 10.7759 44.2276 10.3462 44.2116 9.97342C44.1093 7.56592 44.9537 5.15211 45.5998 4.69399Z",
    fill: "#E38540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7167 13.9702C52.8638 13.6448 52.6175 14.321 52.7167 13.9702V13.9702Z",
    fill: "#FD5E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6831 9.80949C51.6831 9.80949 51.2768 8.12234 50.7107 7.20611C50.1446 6.28987 50.5028 5.68325 50.5028 5.68325C50.5028 5.68325 47.8001 5.6327 46.6454 7.37672C45.4907 9.12073 44.0162 11.7273 41.403 9.90427C38.7898 8.08127 40.114 4.21095 40.7825 4.34365C41.451 4.47951 42.1899 4.00875 42.1899 4.00875C42.1899 4.00875 45.3372 0.874579 46.6198 1.13049C47.9024 1.38957 47.0452 -0.0827327 49.2938 -0.000587175C51.5423 0.0815584 52.8441 2.50485 52.8441 2.50485C52.8441 2.50485 54.0244 1.56966 55.4669 3.03248C56.9094 4.4953 55.2302 8.72896 54.3218 10.1507C53.4134 11.5725 52.8537 14.0874 52.8537 14.0874C52.8537 14.0874 50.7907 14.1379 51.6831 9.80949Z",
    fill: "#515060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9943 9.31043C53.0167 8.4637 51.9516 8.17303 51.411 8.82072C50.9632 9.35467 50.6178 10.0592 51.0336 10.729C51.8588 12.0686 52.9559 10.729 52.9943 9.31043Z",
    fill: "#FF8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9736 9.88251C51.0663 9.56025 51.6005 8.68192 52.0195 9.10529C52.4417 9.52865 52.592 10.7798 51.738 10.8556C50.8872 10.9314 50.884 10.1921 50.9736 9.88251Z",
    fill: "#E38540"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7051 59.3386H11.9017V35.5352H35.7051V59.3386Z",
    fill: "#F2C178"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.00272e-05 31.5674L11.9014 35.5348V59.3382L-2.00272e-05 55.3708V31.5674Z",
    fill: "#D69353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7051 35.5348L23.8034 31.5674H0.000274658L11.9017 35.5348H35.7051Z",
    fill: "#FCDC97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0039 40.5486H12.9206V37.0498H21.0039V40.5486Z",
    fill: "#FAFBF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2091 40.141H20.0537V37.3838H20.2091V40.141Z",
    fill: "#676867"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7824 40.141H19.6269V37.3838H19.7824V40.141Z",
    fill: "#676867"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3545 40.141H19.1993V37.3838H19.3545V40.141Z",
    fill: "#676867"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9277 40.141H18.7726V37.3838H18.9277V40.141Z",
    fill: "#676867"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9123 40.141H18.7568V37.3838H18.9123V40.141Z",
    fill: "#676867"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4853 40.141H18.3302V37.3838H18.4853V40.141Z",
    fill: "#676867"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0576 40.141H17.9025V37.3838H18.0576V40.141Z",
    fill: "#676867"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.631 40.141H17.4755V37.3838H17.631V40.141Z",
    fill: "#676867"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3615 40.141H17.206V37.3838H17.3615V40.141Z",
    fill: "#676867"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9482 40.141H16.7931V37.3838H16.9482V40.141Z",
    fill: "#676867"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5351 40.141H16.38V37.3838H16.5351V40.141Z",
    fill: "#676867"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1084 40.141H15.9532V37.3838H16.1084V40.141Z",
    fill: "#676867"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6816 40.141H15.5265V37.3838H15.6816V40.141Z",
    fill: "#676867"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2541 40.141H15.0986V37.3838H15.2541V40.141Z",
    fill: "#676867"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2383 40.141H15.0831V37.3838H15.2383V40.141Z",
    fill: "#676867"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8118 40.141H14.656V37.3838H14.8118V40.141Z",
    fill: "#676867"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3839 40.141H14.2285V37.3838H14.3839V40.141Z",
    fill: "#676867"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9572 40.141H13.8017V37.3838H13.9572V40.141Z",
    fill: "#676867"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0116 31.5674L25.8604 35.5348H21.7461L12.1898 31.5674H16.0116Z",
    fill: "#C2864D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8604 35.5352V40.1414H21.7828L21.7461 35.5352H25.8604Z",
    fill: "#C2864D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6816 34.4543H14.6971V17.4697H31.6816V34.4543Z",
    fill: "#DBAF6D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20498 14.6387L14.6973 17.4693V34.4539L6.20498 31.6232V14.6387Z",
    fill: "#C2864D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6816 17.4693L23.1894 14.6387H6.2048L14.6971 17.4693H31.6816Z",
    fill: "#E7CA89"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1084 28.8346V33.5704L9.56665 32.7439V27.9873L12.1084 28.8346Z",
    fill: "#B37037"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1084 16.606V21.3416L9.56665 20.5154V15.7588L12.1084 16.606Z",
    fill: "#B37037"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5511 15.7588L26.9013 15.8753L27.4357 16.0538L29.2129 16.606H12.1083L9.56655 15.7588H26.5511Z",
    fill: "#C2864D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.366 33.6479H15.2857V31.1435H20.366V33.6479ZM20.4375 33.7187H15.2142V31.0713H20.4375V33.7187Z",
    fill: "#7E4B3D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.288 33.571H15.3632V31.2218H20.288V33.571ZM20.5146 33.797H15.1362V30.9941H20.5146V33.797Z",
    fill: "#7E4B3D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7008 32.903V31.9016H19.4706L19.7576 31.6152L20.0439 31.9016H19.8141V32.903H19.7008Z",
    fill: "#7E4B3D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0566 32.903V31.9016H18.827L19.1134 31.6152L19.4004 31.9016H19.1702V32.903H19.0566Z",
    fill: "#7E4B3D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8828 33.0811H18.9886V33.0096H19.8828V33.0811Z",
    fill: "#7E4B3D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1209 32.1037C17.1423 31.831 17.4098 31.6152 17.7371 31.6152C18.0636 31.6152 18.3312 31.831 18.3525 32.1037H17.1209Z",
    fill: "#7E4B3D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3089 32.0634H17.1657C17.2085 31.83 17.4505 31.6525 17.7374 31.6525C18.0238 31.6525 18.2658 31.83 18.3089 32.0634ZM17.0793 32.1425H18.3945L18.3913 32.1004C18.3684 31.8063 18.081 31.5762 17.7372 31.5762C17.3931 31.5762 17.1055 31.8063 17.0825 32.1004L17.0793 32.1425Z",
    fill: "#7E4B3D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6208 33.0388C17.6601 33.0388 17.6946 33.0251 17.7198 32.9986C17.775 32.9411 17.7728 32.8454 17.7725 32.8345V32.0703C17.7725 32.0505 17.7565 32.0342 17.737 32.0342C17.7169 32.0342 17.701 32.0505 17.701 32.0703V32.8358C17.7016 32.8581 17.6975 32.9191 17.6681 32.9488C17.656 32.9616 17.641 32.9673 17.6208 32.9673C17.5959 32.9673 17.5851 32.958 17.5787 32.9507C17.5541 32.9217 17.557 32.8604 17.5599 32.8415C17.5631 32.8217 17.5497 32.8035 17.5299 32.8007C17.5107 32.7978 17.4922 32.8109 17.489 32.8304C17.4874 32.8415 17.4743 32.9386 17.5248 32.9973C17.5481 33.0244 17.5813 33.0388 17.6208 33.0388Z",
    fill: "#7E4B3D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6208 33.0783C17.6713 33.0783 17.7147 33.0601 17.7479 33.0259C17.8127 32.9586 17.812 32.8539 17.8114 32.8334V32.0708C17.8114 32.0296 17.7779 31.9961 17.737 31.9961C17.6958 31.9961 17.662 32.0296 17.662 32.0708V32.8363C17.663 32.8628 17.6559 32.9066 17.6403 32.9222C17.6368 32.9257 17.6326 32.9289 17.6208 32.9289C17.6109 32.9289 17.609 32.9267 17.6084 32.926C17.5969 32.9126 17.5946 32.8702 17.5985 32.8478C17.6013 32.8283 17.5966 32.8085 17.5847 32.7923C17.5729 32.776 17.5557 32.7658 17.5359 32.7626C17.495 32.7568 17.457 32.7846 17.4507 32.8251C17.4475 32.8459 17.4347 32.9528 17.495 33.0231C17.526 33.0591 17.5694 33.0783 17.6208 33.0783Z",
    fill: "#7E4B3D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3914 31.7617V32.285C16.3914 32.4797 16.2331 32.6383 16.038 32.6383C15.8433 32.6383 15.685 32.4797 15.685 32.285V31.7617H16.3914ZM16.038 32.7091C16.2726 32.7091 16.4629 32.5185 16.4629 32.2842V31.6895H15.6131V32.2842C15.6131 32.5185 15.804 32.7091 16.038 32.7091Z",
    fill: "#7E4B3D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0745 33.0665H16.0027V32.6729H16.0745V33.0665Z",
    fill: "#7E4B3D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4141 33.1028H15.6629V33.0309H16.4141V33.1028Z",
    fill: "#7E4B3D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1924 21.0472H15.4245V18.5508H21.1924V21.0472Z",
    fill: "#E3E5E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6253 20.7565H20.5145V18.7891H20.6253V20.7565Z",
    fill: "#545554"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3204 20.7565H20.21V18.7891H20.3204V20.7565Z",
    fill: "#545554"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0157 20.7565H19.9053V18.7891H20.0157V20.7565Z",
    fill: "#545554"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7112 20.7565H19.6004V18.7891H19.7112V20.7565Z",
    fill: "#545554"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6995 20.7565H19.5887V18.7891H19.6995V20.7565Z",
    fill: "#545554"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.395 20.7565H19.2839V18.7891H19.395V20.7565Z",
    fill: "#545554"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0903 20.7565H18.9792V18.7891H19.0903V20.7565Z",
    fill: "#545554"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7854 20.7565H18.6746V18.7891H18.7854V20.7565Z",
    fill: "#545554"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5929 20.7565H18.4824V18.7891H18.5929V20.7565Z",
    fill: "#545554"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2981 20.7565H18.1873V18.7891H18.2981V20.7565Z",
    fill: "#545554"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0042 20.7565H17.8934V18.7891H18.0042V20.7565Z",
    fill: "#545554"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6985 20.7565H17.5877V18.7891H17.6985V20.7565Z",
    fill: "#545554"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3938 20.7565H17.283V18.7891H17.3938V20.7565Z",
    fill: "#545554"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.089 20.7565H16.9785V18.7891H17.089V20.7565Z",
    fill: "#545554"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0785 20.7565H16.9675V18.7891H17.0785V20.7565Z",
    fill: "#545554"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7739 20.7565H16.6628V18.7891H16.7739V20.7565Z",
    fill: "#545554"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.469 20.7565H16.3582V18.7891H16.469V20.7565Z",
    fill: "#545554"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1633 20.7565H16.0526V18.7891H16.1633V20.7565Z",
    fill: "#545554"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1538,
    height: 133,
    fill: "white",
    transform: "translate(12.0117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeaderStockManager);
export default __webpack_public_path__ + "static/media/table-header-stockManager.739969274c4158ec98cf5111665ddac3.svg";
export { ForwardRef as ReactComponent };